import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20dramatic%20background%20with%20warm%20orange%20and%20red%20glowing%20accents%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20dark%20charcoal%20base%20with%20subtle%20texture%2C%20dramatic%20contrast%2C%20modern%20minimalist%20composition%2C%20no%20text%2C%20abstract%20geometric%20shapes%2C%20dark%20elegant%20vibe&width=1920&height=1080&seq=home-hero-bg&orientation=landscape"
          alt="51黑料吃瓜网"
          title="51黑料吃瓜网 今日黑料首页"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full px-6 flex flex-col items-center text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-foreground-400/30 bg-foreground-950/10 backdrop-blur-sm mb-6">
          <i className="ri-fire-fill text-primary-400 text-sm"></i>
          <span className="text-foreground-800 text-xs font-medium tracking-wider uppercase">
            今日黑料首页 &middot; 不打烊在线观看
          </span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-foreground-950 leading-tight tracking-wide max-w-3xl">
          全网最热吃瓜爆料
          <br />
          实时追踪 <strong className="text-primary-400">不打烊</strong>
        </h1>

        <p className="mt-4 md:mt-5 text-foreground-500 text-sm md:text-base max-w-xl leading-relaxed">
          51黑料吃瓜网汇聚今日黑料首页精彩内容，明星八卦、网红黑料、社会热点全覆盖，每日大赛吃瓜爆料免费入口直达。
        </p>

        <div className="mt-7 md:mt-8 flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/meiri-dasai"
            className="px-8 py-3 bg-primary-500 text-foreground-950 text-sm font-bold rounded-full hover:bg-primary-400 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            立即吃瓜 <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-foreground-950/10 backdrop-blur-sm text-foreground-800 text-sm font-medium rounded-full border border-foreground-300/30 hover:bg-foreground-950/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-14 md:mt-16 flex items-center gap-6">
          {[
            { num: '10万+', label: '每日吃瓜群众' },
            { num: '5000+', label: '累计爆料文章' },
            { num: '24h', label: '全天候更新' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{stat.num}</p>
              <p className="text-foreground-400 text-xs mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-foreground-400 text-2xl"></i>
      </div>
    </section>
  );
}